import React from "react";
import UploadImmaginiArticolo from "../moduliArticolo/UploadImmaginiArticolo";

function Immagini({
  product,
  token,
  uploadedBy,
  brandCode,
  botProdIDps,
  refreshKey,
  canViewDebugDetails,
  onCompleted,
}) {
  return (
    <section className="modificaProdottiPagina modificaProdottiImmaginiPagina pa2">
      <UploadImmaginiArticolo
        product={product}
        token={token}
        uploadedBy={uploadedBy}
        brandCode={brandCode}
        botProdIDps={botProdIDps}
        refreshKey={refreshKey}
        canViewDebugDetails={canViewDebugDetails}
        onCompleted={onCompleted}
      />
    </section>
  );
}

export default Immagini;
